import { render, staticRenderFns } from "./PriceTable.vue?vue&type=template&id=1c7c539c&scoped=true&"
import script from "./PriceTable.vue?vue&type=script&lang=js&"
export * from "./PriceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7c539c",
  null
  
)

export default component.exports